import {action, computed, observable} from "mobx";
import Widget, {WidgetModelInterface} from "./Widget";
import WidgetsStore from "./WidgetsStore";
import TemplateInterface from "./TemplateInterface";
import {logoWidget, menuDataWidget, postDataWidget} from "./templateData_temp";
import uuidv4 from 'uuid/v4';

// #TODO move to store index.tsx
const widgetsStore = new WidgetsStore();

export class Template implements TemplateInterface {

    id: number;

    key: string;

    displayName: string = '';

    @observable html: string = '';

    @observable widgets: Widget[] = [];

    constructor({displayName, widgets, id, key = uuidv4()}: TemplateInterface) {
        this.displayName = displayName;
        this.id = id;
        this.key = key;

        //#TODO remove Object.assign
        this.widgets = widgets.map(widget => widgetsStore.createWidget(Object.assign({}, widget)));
    }

    addWidget = (type: string, index: number) => {
        const widget: Widget = widgetsStore.createWidget(this.getWidgetData(type));
        this.widgets.splice(index + 1, 0, widget);
    };

    deleteWidget = (widgetIndex: number) => {

        const widgets = this.widgets;
        const currentWidget: any = widgets.find((item: Widget, index: number) => widgetIndex === index);
        const beforeWidget = widgets.find((item: Widget, index: number) => (widgetIndex - 1) === index);
        const afterWidget = widgets.find((item: Widget, index: number) => (widgetIndex + 1) === index);

        if (
            (!beforeWidget && afterWidget && currentWidget.config.type === afterWidget.config.type) ||
            (beforeWidget && !afterWidget && currentWidget.config.type === beforeWidget.config.type) ||
            (beforeWidget && afterWidget && (currentWidget.config.type === beforeWidget.config.type || currentWidget.config.type === afterWidget.config.type))
        ) {

            this.widgets.splice(widgetIndex, 1);
        }

    };

    getWidgetData = (widgetType: string): WidgetModelInterface => {
        if (widgetType === 'Post') {
            return postDataWidget;
        }
        if (widgetType === 'Navigation') {
            return menuDataWidget;
        }
        if (widgetType === 'Logo') {
            return logoWidget;
        }

        return postDataWidget;
    }

    @action setWidgetSelected(widgetIndex: number | null = null) {
        this.widgets.forEach(((widget, index) => widget.isSelected = index === widgetIndex));
    }

    get asJson() {
        return {
            widgets: this.widgets.map((widget: any) => widget.asJson),
            displayName: this.displayName,
            id: this.id,
            html: this.html,
        };
    };

    @computed get isWidgetSelected(): boolean {
        return this.widgets.find((widget) => widget.isSelected) !== undefined;
    }

    @computed get widgetSelectedIndex(): number | null {
        const index = this.widgets.findIndex((widget: Widget) => widget.isSelected);
        return index !== -1 ? index : null;
    }

    @computed get selectedWidget(): Widget | null {
        return this.widgetSelectedIndex !== null ? this.widgets[this.widgetSelectedIndex] : null;
    }

    resetWidgetSelected = () => {
        this.widgets.forEach((widget: Widget) => widget.isSelected = false);
    }

}
